import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getOpportunities = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/opportunities?' + params.toString()); // Let the error bubble up
};

const getOpportunityById = async (id: string) => {
  return await apiClient.get(`/opportunities/${id}`); // Fetch car listing by ID
};

const getOpportunityByStatus = async (opportunity: string, pagination:string) => {
  return await apiClient.get(`/opportunities?filter[current_status]=${opportunity + pagination}`); // Fetch car listing by ID
};

const createOpportunity = async (opportunityData: any) => {
  return await apiClient.post('/opportunities', opportunityData); // Create a new car listing
};

const updateOpportunity = async (id: number, opportunityData: any) => {
  return await apiClient.patch(`/opportunities/${id}`, opportunityData); // Update car listing by ID
};

const deleteOpportunity = async (id: number) => {
  return await apiClient.delete(`/opportunities/${id}`); // Delete car listing by ID
};

const sendMediaKit = async (emails: any) => {
  return await apiClient.post(`/email/send-media-kit`, emails, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export default {
  getOpportunities,
  getOpportunityById,
  createOpportunity,
  updateOpportunity,
  deleteOpportunity,
  getOpportunityByStatus,
  sendMediaKit
};
